import React from "react";

import { InputBase } from "@material-ui/core";

import Button from "@material-ui/core/Button";
import { Dialog } from "../../hooks/useDialog";

import { openConfirm } from "../../components/confirmBox/ConfirmBox";
import {
  NumberFormatCustom,
  padNumber,
  CalendarDialog,
} from "../../common/helpers";

import EditContribution from "./EditContribution";

import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import DateFnsUtils from "@date-io/moment";

import moment from "moment";

import styled from "styled-components";

import { DatePicker } from "@material-ui/pickers";

import CalendarIcon from "@material-ui/icons/CalendarToday";

const getDateValues = (key) => {
  var [year, month, day] = key.split("-");

  if (!day) {
    var tmp = new Date(year, month, 0);

    day = tmp.getDate();
  }

  return {
    year: year.toString(),
    month: month.toString(),
    day: day.toString(),
  };
};

const ContributionsEditDialog = (props) => {
  const { date, onClose } = props;

  const month = padNumber(date.getMonth() + 1);
  const year = date.getFullYear();
  const day = padNumber(date.getDate());

  const key = `${year}-${month}-${day}`;

  return (
    <Dialog
      options={{ maxWidth: "md", fullWidth: true }}
      actionButtons={[
        <Button
          color="primary"
          onClick={() => {
            onClose();
          }}
        >
          Finished
        </Button>,
      ]}
      title={moment(date).format("MMM Do, YYYY")}
    >
      <EditContribution {...props} itemKey={key} />
    </Dialog>
  );
};

const DataCellRow = styled.div`
  border-top: 1px solid #b7b7b7;
  // border-bottom: 1px solid black;
  margin-top: -1px;
  display: flex;
  // padding: 5px;
`;
const DateCell = styled.div`
  padding: 10px;
  width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
  // margin: -1px -1px auto 0;
  // height: 20px;
`;

const Ellipses = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`;

const DataRowHeading = () => {
  return (
    <DataCellRow style={{ textAlign: "center" }}>
      <DateCell>Date</DateCell>
      <DateCell style={{ borderLeft: "1px solid #b7b7b7", width: 240 }}>
        <div style={{ fontWeight: "bold" }}>Contributions</div>
        <div style={{ display: "flex", marginTop: 5 }}>
          <div style={{ width: 110, marginTop: 10 }}>Cash</div>
          <div style={{ width: 110 }}>
            Securities <br />
            <span style={{ fontSize: 12, fontStyle: "italic" }}>
              at market value
            </span>
          </div>
        </div>
      </DateCell>
      <DateCell style={{ borderLeft: "1px solid #b7b7b7", width: 240 }}>
        <div style={{ fontWeight: "bold" }}>Withdrawals</div>
        <div style={{ display: "flex", marginTop: 5 }}>
          <div style={{ width: 110, marginTop: 10 }}>Cash</div>
          <div style={{ width: 110 }}>
            Securities <br />
            <span style={{ fontSize: 12, fontStyle: "italic" }}>
              at market value
            </span>
          </div>
        </div>
      </DateCell>
      <DateCell style={{ borderLeft: "1px solid #b7b7b7", paddingTop: 50 }}>
        Manager Fees
      </DateCell>
      <div style={{ borderLeft: "1px solid #b7b7b7" }}></div>
    </DataCellRow>
  );
};

const getValueString = (val, showZero = true) => {
  return (
    <Ellipses title={"$" + val}>
      {val ? `$${val}` : showZero ? "$0" : ""}
    </Ellipses>
  );
};

const Input = (props) => {
  const { row, portfolio, type, actions, itemType = "contribution" } = props;

  return (
    <InputBase
      value={row[type] ? row[type] : ""}
      inputComponent={NumberFormatCustom}
      inputProps={{
        style: {
          padding: 5,
          // backgroundColor: !item.value && !yearIndex === 0 && rowIndex === 0 ? '#f9dbdb' : 'initial',
          border: "1px solid #c8c6e6",
          borderRadius: 10,
        },
      }}
      onChange={(event) => {
        actions.setPortfolioContributionValue(
          props,
          portfolio.portfolioNumber,
          type,
          event.target.value,
          row.key,
          itemType
        );
        // actions.setPortfolioItemValue(props, portfolio.portfolioNumber, "value", event.target.value, item.key);
      }}
    />
  );
};

const DataRow = (props) => {
  var { row, actions, portfolio, mode = "input" } = props;

  const [showEdit, showEdit_set] = React.useState();

  return (
    <DataCellRow>
      <DateCell style={{ margin: "auto 0px" }}>
        {moment(row.key).format("MMM DD")}
      </DateCell>
      <DateCell style={{ borderLeft: "1px solid #b7b7b7" }}>
        {mode === "input" ? (
          <Input {...props} type="contribution" />
        ) : (
          getValueString(row.contribution)
        )}
      </DateCell>
      <DateCell>
        {mode === "input" ? (
          <Input {...props} type="securitiesTransferred" />
        ) : (
          getValueString(row.securitiesTransferred)
        )}
      </DateCell>
      <DateCell style={{ borderLeft: "1px solid #b7b7b7" }}>
        {mode === "input" ? (
          <Input {...props} type="cashWithdrawl" />
        ) : (
          getValueString(row.cashWithdrawl)
        )}
      </DateCell>
      <DateCell>
        {mode === "input" ? (
          <Input {...props} type="securitiesWithdrawn" />
        ) : (
          getValueString(row.securitiesWithdrawn)
        )}
      </DateCell>
      <DateCell
        style={{
          borderLeft: "1px solid #b7b7b7",
          borderRight: "1px solid #b7b7b7",
        }}
      >
        {mode === "input" ? (
          <Input {...props} type="feePaidToManager" itemType="fees" />
        ) : (
          getValueString(row.feePaidToManager)
        )}
      </DateCell>
      {mode !== "input" && (
        <div>
          <Button
            color={"primary"}
            onClick={() => {
              showEdit_set(true);
            }}
          >
            Edit
          </Button>
        </div>
      )}
      <div style={{ margin: "auto auto" }}>
        <Button
          color={"secondary"}
          onClick={() => {
            openConfirm({
              title: "Remove Date",
              description:
                "Are you sure you want to remove all contributions, withdrawals, and fees entered for this date?",
              callback: () => {
                actions.removeContribution(
                  props,
                  portfolio.portfolioNumber,
                  row.key
                );
              },
            });
          }}
        >
          Remove
        </Button>
      </div>
      {showEdit && (
        <div>
          <ContributionsEditDialog
            {...props}
            date={new Date(row.year, parseInt(row.month, 10) - 1, row.day)}
            onClose={() => {
              showEdit_set(false);
            }}
          />
        </div>
      )}
    </DataCellRow>
  );
};

const Render = (props) => {
  const { portfolio, actions } = props;

  const [dialogDate, dialogDate_set] = React.useState();

  const [showEdit, showEdit_set] = React.useState(false);
  const [showDatePicker, showDatePicker_set] = React.useState(false);

  const [selectedYear] = React.useState("all");

  var [selectedDate, selectedDate_set] = React.useState(null);

  var rows = [];

  portfolio.contributions.forEach((cont) => {
    var t = getDateValues(cont.key);

    rows.push({ ...cont, ...t });
  });

  portfolio.fees.forEach((cont) => {
    var found = rows.find((e) => e.key === cont.key);

    if (found) {
      found.feePaidToManager = cont.feePaidToManager;
    } else {
      var t = getDateValues(cont.key);
      rows.push({ ...cont, ...t });
    }
  });

  portfolio.portfolioValues.forEach((cont) => {
    var t = getDateValues(cont.key);
    rows.push({ ...cont, isPortfolioValue: true, ...t });
  });

  rows = rows.sort((a, b) => (a.key > b.key ? 1 : -1));

  var contRows = rows
    .filter((e) => !e.isPortfolioValue)
    .sort((a, b) => (a.key > b.key ? 1 : -1));

  var years = [];

  if (rows.length > 0) {
    const [yStart] = rows[0].key.split("-");
    const [yEnd] = rows[rows.length - 1].key.split("-");

    for (var i = yStart; i <= yEnd; i++) {
      years.push(i);
    }
  }

  if (selectedYear !== "all") {
    rows = rows.filter((e) => e.year.toString() === selectedYear.toString());
  }

  var minDate = new Date(rows[0].year, rows[0].month);
  var maxDate = new Date(
    rows[rows.length - 1].year,
    +rows[rows.length - 1].month
  );

  maxDate.setDate(maxDate.getDate() - 1);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div style={{ marginTop: -20 }}>
        {years.map((year, yearIndex) => (
          <div
            key={year}
            style={{
              border: "1px solid #b7b7b7",
              marginBottom: 20,
              maxWidth: 900,
            }}
          >
            <div style={{ display: "flex" }}>
              <div style={{ fontSize: 20, margin: 10, width: "100%" }}>
                {year}
              </div>
              <div style={{ whiteSpace: "nowrap", margin: 10 }}>
                <Button
                  color={"primary"}
                  variant={"outlined"}
                  onClick={(e) => {
                    if (
                      !selectedDate ||
                      selectedDate.getFullYear().toString() !== year
                    ) {
                      selectedDate_set(new Date(year, 0, 1));
                    }

                    setTimeout(() => {
                      showDatePicker_set(true);
                    }, 100);
                  }}
                >
                  <CalendarIcon style={{ marginRight: 10 }} /> Add Date
                </Button>
                <DatePicker
                  style={{ display: "none" }}
                  open={showDatePicker}
                  animateYearScrolling
                  minDate={minDate}
                  maxDate={maxDate}
                  value={selectedDate}
                  initialFocusedDate={selectedDate}
                  onClose={() => {
                    showDatePicker_set(false);
                  }}
                  onChange={(date) => {
                    date = date.toDate();

                    if (date) {
                      const month = padNumber(date.getMonth() + 1);
                      const year = date.getFullYear();
                      const day = padNumber(date.getDate());

                      const key = `${year}-${month}-${day}`;
                      actions.addContributionDate(
                        props,
                        portfolio.portfolioNumber,
                        key
                      );
                    }

                    selectedDate_set(date);
                    showDatePicker_set(false);
                  }}
                />
              </div>
            </div>
            {showEdit && (
              <div>
                <ContributionsEditDialog
                  {...props}
                  date={selectedDate}
                  onClose={() => {
                    showEdit_set(false);
                  }}
                />
              </div>
            )}
            {contRows.filter((e) => e.year.toString() === year.toString())
              .length > 0 && <DataRowHeading />}
            {contRows.filter((e) => e.year.toString() === year.toString())
              .length === 0 && (
              <DataCellRow
                style={{ color: "#797878", textAlign: "center", padding: 10 }}
              >
                There are no contributions, withdrawals, or fees entered for
                this year.
              </DataCellRow>
            )}
            {contRows
              .filter((e) => e.year.toString() === year.toString())
              .sort((a, b) => (a.key > b.key ? 1 : -1))
              .map((item, rowIndex) => (
                <div key={item.key}>
                  <DataRow {...props} row={item} />
                </div>
              ))}
          </div>
        ))}
        {dialogDate && (
          <div>
            <CalendarDialog
              dateClick={(date) => {
                if (date) {
                  const month = padNumber(date.getMonth() + 1);
                  const year = date.getFullYear();
                  const day = padNumber(date.getDate());

                  const key = `${year}-${month}-${day}`;
                  actions.addContributionDate(
                    props,
                    portfolio.portfolioNumber,
                    key
                  );
                }

                dialogDate_set();
              }}
              dialogDate={dialogDate}
            />
          </div>
        )}
      </div>
    </MuiPickersUtilsProvider>
  );
};

const Title = "Portfolio Values";

const getErrors = (props) => {
  const ret = [];

  const { portfolio } = props;

  if (
    portfolio.portfolioValues.filter((e, i) => i !== 0).find((e) => !e.value)
  ) {
    ret.push("All months must have a closing monthly value.");
  }

  if (portfolio.portfolioValues.length < 10) {
    ret.push("A minimum of 10 months are required for analysis.");
  }

  return ret;
};

const Description = () => {
  return (
    <div>
      <p>
        Click Add Date to add any standardized Contributions, Withdrawals, and
        Management Fees to that dates entries. Make sure to enter the PPF
        converted values, not the actual values.
      </p>
    </div>
  );
};

const Preview = (props) => {
  const { portfolio } = props;

  var rows = [];

  portfolio.contributions.forEach((cont) => {
    var t = getDateValues(cont.key);

    rows.push({ ...cont, ...t });
  });

  portfolio.fees.forEach((cont) => {
    var t = getDateValues(cont.key);

    var found = rows.find(
      (e) => e.year === t.year && e.month === t.month && e.day === t.day
    );

    if (found) {
      found.feePaidToManager = cont.feePaidToManager;
    } else {
      rows.push({ ...cont, ...t });
    }
  });

  portfolio.portfolioValues.forEach((cont) => {
    var t = getDateValues(cont.key);

    var found = rows.find(
      (e) => e.year === t.year && e.month === t.month && e.day === t.day
    );

    if (found) {
      found.value = cont.value;
      found.isPortfolioValue = true;
    } else {
      rows.push({
        ...cont,
        isPortfolioValue: true,
        ...t,
        key: `${t.year}-${t.month}-${t.day}`,
      });
    }
  });

  rows = rows.sort((a, b) => (a.key > b.key ? 1 : -1));

  // var years = [];

  // if (rows.length > 0) {
  //     const [yStart] = rows[0].key.split('-');
  //     const [yEnd] = rows[rows.length - 1].key.split('-');

  //     for (var i = yStart; i <= yEnd; i++) {
  //         years.push(i);
  //     }
  // }
  return (
    <div>
      <div style={{ display: "flex" }}>
        <PreviewCell></PreviewCell>
        <PreviewCell></PreviewCell>
        <PreviewCell
          style={{
            width: 210,
            textAlign: "center",
            fontWeight: "bold",
            borderLeft: "1px solid black",
          }}
        >
          Contributions
        </PreviewCell>
        <PreviewCell
          style={{
            width: 210,
            textAlign: "center",
            fontWeight: "bold",
            borderLeft: "1px solid black",
          }}
        >
          Withdrawals
        </PreviewCell>
        <PreviewCell style={{ borderLeft: "1px solid black" }}></PreviewCell>
      </div>
      <div style={{ display: "flex", borderBottom: "1px solid black" }}>
        <PreviewCell>Date</PreviewCell>
        <PreviewCell>Month End</PreviewCell>
        <PreviewCell style={{ borderLeft: "1px solid black" }}>
          Cash
        </PreviewCell>
        <PreviewCell>Securities</PreviewCell>
        <PreviewCell style={{ borderLeft: "1px solid black" }}>
          Cash
        </PreviewCell>
        <PreviewCell>Securities</PreviewCell>
        <PreviewCell style={{ borderLeft: "1px solid black" }}>
          Manager Fees
        </PreviewCell>
      </div>
      {rows.map((row) => (
        <div key={row.key} style={{ display: "flex" }}>
          <PreviewCell>
            {moment(`${row.year}-${row.month}-${row.day}`).format(
              "MMM Do, YYYY"
            )}
          </PreviewCell>
          <PreviewCell
            style={{ fontWeight: row.isPortfolioValue ? "bold" : "" }}
          >
            {row.isPortfolioValue ? getValueString(row.value) : "--"}
          </PreviewCell>
          <PreviewCell style={{ borderLeft: "1px solid black" }}>
            {getValueString(row.contribution, false)}
          </PreviewCell>
          <PreviewCell>
            {getValueString(row.securitiesTransferred, false)}
          </PreviewCell>
          <PreviewCell style={{ borderLeft: "1px solid black" }}>
            {getValueString(row.cashWithdrawl, false)}
          </PreviewCell>
          <PreviewCell>
            {getValueString(row.securitiesWithdrawn, false)}
          </PreviewCell>
          <PreviewCell style={{ borderLeft: "1px solid black" }}>
            {getValueString(row.feePaidToManager, false)}
          </PreviewCell>
        </div>
      ))}

      {/* {groupBy(rows, 'year').sort((a, b) => valueSort(a, b, 'key')).map((year, yI) => <div key={year.key} style={{ width: 'fit-content' }}>
            {groupBy(year.items, 'month').sort((a, b) => valueSort(a, b, 'key')).map((month, mI) => <div key={month.key} style={{ marginBottom: 20 }}>
                
            </div>)}
        </div>)} */}
    </div>
  );
};

const PreviewCell = styled.div`
  width: 100px;
  padding: 5px;
  font-size: 14px;
  text-align: center;
`;

function isComplete(props) {
  const errors = getErrors(props);

  return errors.length === 0;
}

export default Render;

export { isComplete, Render, Title, Description, Preview, getErrors };



// WEBPACK FOOTER //
// ./src/portfolioEntryWizard/components/PortfolioContributionsWithdrawals.js